import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        minWidth: 200,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => <HoverCopyCell value={row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên loại sự cố',
        minWidth: 300,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => <HoverCopyCell value={row.name} />,
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        minWidth: 300,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => <HoverCopyCell value={row.description} />,
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        minWidth: 150,
        flex: 1,
        sortable: true,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
